export const setInvalid = element => {
    sbPopup(notificationText, 'error');
    element.classList.add('invalid');

    removeInvalid(element);
}

export const removeInvalid = element => {
    const listenToClick = event => {
        event.target.removeEventListener(event.type, listenToClick);
        element.classList.remove('invalid');
    };

    element.addEventListener('click', listenToClick);
}
